import { InfoBadge } from 'modules/campaigns/editor/styles';
import { useTemplateContext } from '../../../context';
import { PushPrimaryContent } from '../../../types';
import { LightText } from '../Sections.styled';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

export const PushSendingInformationSection = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent } = templateAndContent;
  const { interruptionLevel, relevanceScore, badge, contentAvailable, isSilentPush } =
    (primaryContent as PushPrimaryContent) || {};

  return (
    <>
      <CampaignFormField
        labelText="Interruption level"
        restrictionText={<InfoBadge>iOS 15+</InfoBadge>}
      >
        <ReadOnlyField name="interruptionLevel">
          {interruptionLevel || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField
        labelText="Relevance score"
        restrictionText={<InfoBadge>iOS 15+</InfoBadge>}
      >
        <ReadOnlyField name="reveranceScore">
          {relevanceScore || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Badge count" restrictionText={<InfoBadge>iOS</InfoBadge>}>
        <ReadOnlyField name="badgeCount">{badge || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Wake up" restrictionText={<InfoBadge>iOS</InfoBadge>}>
        <ReadOnlyField name="wakeUp">
          {contentAvailable ? 'On' : <LightText>Off</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Deliver silently">
        <ReadOnlyField name="deliverSilently">
          {isSilentPush ? 'On' : <LightText>Off</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
    </>
  );
};
